import { print } from 'graphql';
import { DocumentNode } from 'graphql/language';
import { gql as gqlTag } from 'graphql-tag';

export const gql = (documentNode: DocumentNode) =>
  gqlTag(print(documentNode));
